<template>

  <el-container class="common-container">
    <!-- 头部区域 -->
    <!-- <el-button
      type="primary"

      v-loading.fullscreen.lock="fullscreenLoading">
      指令方式
    </el-button> -->

    <el-container>
      <!-- 侧边栏 -->
      <el-aside width="200px">
        <div class="logo">
          <img src="../assets/pictures/bnhlogo.png" height="32" alt="Logo">
        </div>

        <el-menu background-color="#304154" text-color="rgb(191, 203, 217)" active-text-color="rgb(64, 158, 255)"
          :default-active="activeMenu" class="el-menu-vertical-demo" unique-opened>
          <!-- 产品管理 -->
          <el-submenu id="1" index='1' v-show="false">
            <template slot="title">
              <i class="el-icon-s-goods" style="color: inherit"></i>
              <span>产品管理</span>
            </template>
            <!-- index="2" -->
            <el-menu-item id="17" index='product' @click="product()" v-show="false">
              <i class="el-icon-document" style="color: inherit"></i>
              <span slot="title">产品类型</span>
            </el-menu-item>
            <!--  index='3' -->
            <el-menu-item id="18" index="productseting" @click="ProductSeting()" v-show="false">
              <i class="el-icon-setting" style="color: inherit"></i>
              <span slot="title">产品设置</span>
            </el-menu-item>
            <!--  index='4' -->
            <el-menu-item id="19" index="productmanage" @click="ProductManage()" v-show="false">
              <i class="el-icon-search" style="color: inherit"></i>
              <span slot="title">产品查询</span>
            </el-menu-item>
            <!--  index='5' -->
            <el-menu-item id="20" index="productsetmater" @click="ProductSetMater()" v-show="false">
              <i class="el-icon-setting" style="color: inherit"></i>
              <span slot="title">产品物料设置</span>
            </el-menu-item>
          </el-submenu>

          <!--  index='6' -->
          <el-menu-item id="2" index="materia" @click="materia()" v-show="false">
            <i class="el-icon-coin" style="color: inherit"></i>
            <span slot="title">物料管理</span>
          </el-menu-item>

          <!-- 仓储管理 -->
          <el-submenu id="3" index='7' v-show="false">
            <template slot="title">
              <i class="el-icon-office-building" style="color: inherit"></i>
              <span>仓储管理</span>
            </template>
            <!--  index='8' -->
            <el-menu-item id="21" index="warehouse" @click="wareHouse()" v-show="false">
              <i class="el-icon-document" style="color: inherit"></i>
              <span slot="title">仓库信息</span>
            </el-menu-item>
            <!--  index='9' -->
            <el-menu-item id="22" index="storage" @click="storage()" v-show="false">
              <i class="el-icon-document" style="color: inherit"></i>
              <span slot="title">仓库储位信息</span>
            </el-menu-item>
            <!--  index='10' -->
            <el-menu-item id="23" index="warehousemanage" @click="WareHouseManage()" v-show="false">
              <i class="el-icon-document" style="color: inherit"></i>
              <span slot="title">库存信息</span>
            </el-menu-item>
          </el-submenu>

          <el-menu-item id="4" index='11' @click="Warning()" v-show="false">
            <i class="el-icon-warning" style="color: inherit"></i>
            <span slot="title">库存报警</span>
          </el-menu-item>
          <!-- 变量管理 -->
          <!-- <el-submenu id="5"   index ='12' v-show="false">
            <template slot="title">
              <i class="el-icon-coin" style="color: white"></i>
              <span>变量管理</span>
            </template>
            <el-menu-item id="24" index ='13'  @click="VariableMainten()"  v-show="false">
              <i class="el-icon-discount" style="color: white"></i>
              <span slot="title">变量维护</span>
            </el-menu-item>
            <el-menu-item id="25"  index ='14' @click="VariableAttr()"  v-show="false">
              <i class="el-icon-price-tag" style="color: white"></i>
              <span slot="title">变量归属</span>
            </el-menu-item>
          </el-submenu> -->

          <!-- 报警管理 -->
          <el-submenu id="6" index='15' v-show="false">
            <template slot="title">
              <i class="el-icon-warning" style="color: inherit"></i>
              <span>报警管理</span>
            </template>
            <!--  index='16' -->
            <el-menu-item id="26" index="warningseting" @click="WarningSeting()" v-show="false">
              <i class="el-icon-setting" style="color: inherit"></i>
              <span slot="title">报警设置</span>
            </el-menu-item>
            <!--  index='17' -->
            <el-menu-item id="27" index="warnsetlist" @click="WarnSetList()" v-show="false">
              <i class="el-icon-document" style="color: inherit"></i>
              <span slot="title">报警设置列表</span>
            </el-menu-item>
            <el-menu-item id="28" index='18' @click="WarningMonitor()" v-show="false">
              <i class="el-icon-monitor" style="color: inherit"></i>
              <span slot="title">报警监控</span>
            </el-menu-item>
          </el-submenu>

          <el-submenu id="7" index='19' v-show="false">
            <template slot="title">
              <i class="el-icon-box" style="color: inherit"></i>
              <span>出入库</span>
            </template>
            <!--  index='20' -->
            <el-menu-item id="29" index="storagein" @click="StorageIn()" v-show="false">
              <i class="el-icon-sell" style="color: inherit"></i>
              <span slot="title">入库</span>
            </el-menu-item>
            <!--  index='21' -->
            <el-menu-item id="30" index="storageout" @click="StorageOut()" v-show="false">
              <i class="el-icon-sold-out" style="color: inherit"></i>
              <span slot="title">出库</span>
            </el-menu-item>
          </el-submenu>

          <!--  index='22' -->
          <el-menu-item id="8" index="inventory" @click="Inventory()" v-show="false">
            <i class="el-icon-coin" style="color: inherit"></i>
            <span slot="title">盘点</span>
          </el-menu-item>

          <!--  index='23' -->
          <el-menu-item id="9" index="plcsetting" @click="PlcSetting()" v-show="false">
            <i class="el-icon-set-up" style="color: inherit"></i>
            <span slot="title">通信设置</span>
          </el-menu-item>

          <el-submenu id="14" index='25' v-show="false">
            <template slot="title">
              <i class="el-icon-user-solid" style="color: inherit"></i>
              <span>用户管理</span>
            </template>
            <!--  index='26' -->
            <el-menu-item id="31" index="usermanage" @click="UserManage()" v-show="false">
              <i class="el-icon-document" style="color: inherit"></i>
              <span slot="title">用户列表</span>
            </el-menu-item>
            <!--  index='27' -->
            <el-menu-item id="32" index="userroleset" @click="UserRoleSet()" v-show="false">
              <i class="el-icon-document" style="color: inherit"></i>
              <span slot="title">角色配置</span>
            </el-menu-item>
            <!--  index='28' -->
            <el-menu-item id="33" index="usertypemanage" @click="UserTypeManage()" v-show="false">
              <i class="el-icon-document" style="color: inherit"></i>
              <span slot="title">类型管理</span>
            </el-menu-item>
          </el-submenu>

          <el-submenu id="15" index='29' v-show="false">
            <template slot="title">
              <i class="el-icon-s-ticket" style="color: inherit"></i>
              <span>权限管理</span>
            </template>
            <!--  index='30' -->
            <el-menu-item id="34" index="rolemanage" @click="RoleManage()" v-show="false">
              <i class="el-icon-document" style="color: inherit"></i>
              <span slot="title">角色管理</span>
            </el-menu-item>
            <!--  index='31' -->
            <el-menu-item id="35" index="menumanage" @click="MenuManage()" v-show="false">
              <i class="el-icon-document" style="color: inherit"></i>
              <span slot="title">菜单管理</span>
            </el-menu-item>
          </el-submenu>

          <el-submenu id="16" index='32' v-show="false">
            <template slot="title">
              <i class="el-icon-s-ticket" index='33' style="color: inherit"></i>
              <span>组织管理</span>
            </template>
            <!-- index='34' -->
            <el-menu-item id="36" index="department" @click="Department()" v-show="false">
              <i class="el-icon-document" style="color: inherit"></i>
              <span slot="title">部门管理</span>
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </el-aside>
      <!-- 主体区域 -->
      <el-main>
        <template>
          <div style="position: absolute;right: 40px;">
            <el-dropdown :hide-on-click="false">
              <span class="el-dropdown-link" style="color: #0e85f5;font-weight: bolder">{{ UserName }}
              </span>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item><a @click="logout">退出登录</a></el-dropdown-item>
                  <!-- <el-dropdown-item  ><a @click="IntelligentWarehousingVisualization">智能仓储可视化</a></el-dropdown-item>
              <el-dropdown-item  ><a @click="log">数据仓库看板</a></el-dropdown-item> -->
                  <!-- <el-dropdown-item disabled>Action 4</el-dropdown-item>
              <el-dropdown-item divided>Action 5</el-dropdown-item> -->
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
        </template>
        <router-view></router-view>
      </el-main>
    </el-container>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <span>这是一段信息</span>
    </el-dialog>
  </el-container>
</template>

<script>
// import axios from 'axios'
// import qs from 'qs'

export default {
  data() {
    return {
      dialogVisible: false,
      getTypeList: {
        privateKey: '12a5081e-e354-bada-3952-7a0df30d8849',
        appIdentification: 'wms',
      },
      dialogVisible: false,
      ID: '',
      messagelist: '',
      UserName: '',
      sites: {},
      fullscreenLoading: false
    }
  },
  created() {
    this.openFullScreen1()
    this.getType()

    // let reg = location.href
    // let strArr = reg.split('=')
    // let token = strArr[1]

    // axios.post('http://192.168.1.110:803/IDM/SystemObtainUser',qs.stringify({
    //   PrivateKey:'d265e452-4e9a-74b8-5092-01d00539a1de',
    //     AppIdentification:'WMS',
    //     Token:token
    // })).then(res=>{
    //   console.log(111,res);
    //    window.sessionStorage.setItem('token', res.data.data.UserNumber)
    //               this.$router.push("/common")
    // })
  },
  mounted() {
    // this.getType()
    // setInterval(() => {
    //     this.getType()
    // }, 3000)
  },
  computed: {
    activeMenu() {
      return this.$route.path.split('/')[1] || '/home'
    }
  },
  methods: {
    product() {
      this.$router.push("/product")
    },
    openFullScreen1() {
      this.fullscreenLoading = true;
      setTimeout(() => {
        this.fullscreenLoading = false;
      }, 2000);
    },
    materia() {
      this.$router.push("/materia")
    },
    wareHouse() {
      this.$router.push("/warehouse")
    },
    storage() {
      this.$router.push("/storage")
    },
    ProductSeting() {
      this.$router.push("/productseting")
    },
    WareHouseManage() {
      this.$router.push("/warehousemanage")
    },
    ProductManage() {
      this.$router.push("/productmanage")
    },
    Warning() {
      this.$router.push("/warning")
    },
    VariableMainten() {
      this.$router.push("/variablemainten")
    },
    WarningSeting() {
      this.$router.push("/warningseting")
    },
    WarnSetList() {
      this.$router.push("/warnsetlist")
    },
    WarningMonitor() {
      // this.$router.push("/warningmonitor")
      // window.open('http://120.46.209.88:3455/#/warningmonitor', '_blank')
      window.open(`${this.$qian}warningmonitor`, '_blank')
    },
    IntelligentWarehousingVisualization() {
      window.open(`${this.$qian}IntelligentWarehousingVisualization`, '_blank')
    },
    log() {
      window.open(`${this.$qian}logOne`, '_blank')
      // window.open('http://192.168.1.111:8115/#/logOne', '_blank')
      // window.open('http://120.46.209.88:3455/#/logOne', '_blank')
    },
    ProductSetMater() {
      this.$router.push("/productsetmater")
    },
    StorageIn() {
      this.$router.push("/storagein")
    },
    StorageOut() {
      this.$router.push("/storageout")
    },
    Inventory() {
      this.$router.push("/inventory")
    },
    PlcSetting() {
      this.$router.push("/plcsetting")
    },
    ProcessManage() {
      this.$router.push("/processmanage")
    },
    CraftManage() {
      this.$router.push("/craftmanage")
    },
    VariableAttr() {
      this.$router.push("/variableattr")
    },
    close() {
    },
    open() {
    },
    handleClose() {
    },
    // RobotMonitor () {
    //     window.open('http://192.168.1.108:8115/#/robotmonitor', '_blank')
    //     //window.open('http://192.168.200.253:80/#/robotmonitor', '_blank')
    // },
    Order() {
      this.$router.push("/order")
    },
    Workpiecemanage() {
      this.$router.push("/workpiecemanage")
    },
    // AutoRobotMonitor () {
    //     window.open('http://192.168.1.108:8115/#/autorobotmonitor', '_blank')
    //     //window.open('http://192.168.200.253:80/#/autorobotmonitor', '_blank')
    // },
    // Assemble () {
    //     window.open('http://192.168.1.108:8115/#/assemble', '_blank')
    //     //window.open('http://192.168.200.253:80/#/assemble', '_blank')
    // },
    // AllMessage () {
    //     window.open('http://192.168.1.108:8115/#/allmessage', '_blank')
    //     //window.open('http://192.168.200.253:80/#/allmessage', '_blank')
    // },
    ProductInspection() {
      this.$router.push("/productinspection")
    },
    RobotStatistics() {
      this.$router.push("/robotstatistics")
    },
    RobotElectricity() {
      this.$router.push("/robotelectricity")
    },
    IntelligentStorage() {
      this.$router.push("/intelligentstorage")
    },
    IntellStorageElec() {
      this.$router.push("/intellstorageelec")
    },
    UserManage() {
      this.$router.push("/usermanage")
    },
    RoleManage() {
      this.$router.push("/rolemanage")
    },
    UserRoleSet() {
      this.$router.push("/userroleset")
    },
    UserTypeManage() {
      this.$router.push("/usertypemanage")
    },
    MenuManage() {
      this.$router.push("/menumanage")
    },
    Department() {
      this.$router.push("/department")
    },
    logout() {
      window.sessionStorage.clear()
      // this.$router.replace("/login")
      // window.open('http://localhost:5173/#/login', "_blank")
      // window.location.href = `${path}`
      window.location.href = this.$path
    },
    //调用接口查询消息提示
    async getType() {
      let params = new URLSearchParams();
      params.append("privateKey", this.getTypeList.privateKey)
      params.append("appIdentification", this.getTypeList.appIdentification)
      params.append("ID", window.sessionStorage.getItem("token"))
      const { data: res } = await this.$http.post('/User/SelectUserRoleMenu', params)
      this.UserName = res.UserName
      if (res.code == 0) {
        // this.$message.error(res.message)
        // this.$router.replace("/login")
        window.location.href = this.$path
        // window.location.href = this.$port
      }

      for (let i in res.data)
        document.getElementById(String(res.data[i].ID)).style.display = ""
    }
  }
}
</script>

<style lang="less" scoped>
.example-showcase .el-dropdown+.el-dropdown {
  margin-left: 15px;
}

.common-container {
  height: 100%;
}

.el-header {
  background-color: #409eff;
  display: flex;
  justify-content: space-between;
  padding-left: 0;
  align-items: center;
  color: rgb(255, 255, 255);
  font-size: 25px;
  font-family: 'Courier New', Courier, monospace;

  >div {
    display: flex;
    align-items: center;

    span {
      margin-left: 20px;
    }
  }
}

.picture {
  margin-left: 1%;
  height: 4%;
  width: 4%;
}

.el-aside {
  background-color: #304155;

  .el-menu {
    border-right: none;
  }
}

/* 文字 */
::v-deep.el-submenu.is-active>.el-submenu__title {

  // background-color: #545c64 !important;
  span {
    color: #ffffff;
  }
}


::v-deep .el-submenu.is-active>.el-submenu__title i {
  color: #ffffff !important;
}

// 设置二级菜单被选中的颜色
// .el-menu-item.is-active {
//   // background-color: #2196f3 !important;
//   // color: #fff;
//   span {
//     color: #2196f3 !important;
//   }
// }
// .test01 {
//   background-color: #1772b4;
// }
.demo-type {
  display: flex;
}

.demo-type>div {
  flex: 1;
  text-align: center;
}

.demo-type>div:not(:last-child) {
  border-right: 1px solid var(--el-border-color);
}

.ee {
  height: 1%;
  color: #409eff;

  font-size: 25px;
  font-family: 'Courier New', Courier, monospace;
}

.example-showcase .el-dropdown+.el-dropdown {
  margin-left: 15px;
}

.example-showcase .el-dropdown-link {
  cursor: pointer;
  color: var(--el-color-primary);
  display: flex;
  align-items: center;
}

.logo img {
  height: 32px;
  // width: 150px; /* 设置 logo 图片的宽度 */
  // margin-right: 1%; /* 设置 logo 和文本之间的右边距 */
  margin: 3% 0;
}

.logo {
  display: flex;
  margin-right: 1%;
  /* 设置 logo 和文本之间的右边距 */
  // margin-top: 3%;
  align-items: center;
  /* 垂直居中对齐 */
  justify-content: center;
  height: 50px;
}

.el-submenu .el-menu-item {
  background-color: #1f2d3d !important;
}

.el-submenu .el-menu-item:hover {
  background-color: #001528 !important;
}
</style>
